import { HttpContext, HttpContextToken } from '@angular/common/http';

// Opt-out tokens for default-on interceptors. Default `false` = "do not skip"
// (the interceptor runs). `.skip*()` flips the matching token to `true`.
export const SKIP_LANGUAGE = new HttpContextToken<boolean>(() => false);

// Opt-in tokens for additive interceptors. Default `false` = "inactive"
// (the interceptor no-ops). `.add*()` flips the matching token to `true`.
export const ADD_ASSETS_PREFIX = new HttpContextToken<boolean>(() => false);

/**
 * Builds a fresh {@link HttpContext} that carries every entry the caller already
 * had plus each requested token set to `true`. The caller's context is never
 * mutated, so a context reused across requests cannot leak skip/add flags onto
 * later requests.
 */
export function withSkips(tokens: ReadonlySet<HttpContextToken<boolean>>, base?: HttpContext): HttpContext {
    const context = new HttpContext();
    if (base) {
        for (const token of base.keys()) {
            context.set(token, base.get(token));
        }
    }
    tokens.forEach((token) => context.set(token, true));
    return context;
}
